import { render, staticRenderFns } from "./DocumentPresentation.vue?vue&type=template&id=5f97ac5c&scoped=true&"
import script from "./DocumentPresentation.vue?vue&type=script&lang=ts&"
export * from "./DocumentPresentation.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentPresentation.vue?vue&type=style&index=0&id=5f97ac5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f97ac5c",
  null
  
)

export default component.exports